import React, { useCallback } from 'react';
import Box from '@wconcept/wconcept-ui-renewal/components/atoms/Box';
import Img from '@wconcept/wconcept-ui-renewal/components/atoms/Img';
import Text from '@wconcept/wconcept-ui-renewal/components/atoms/Text';
import ModalEdgeCloseBtn from '@wconcept/wconcept-ui-renewal/components/molecules/_btn/ModalEdgeCloseBtn';
import ModalCloseBtn from '@wconcept/wconcept-ui-renewal/components/molecules/_btn/ModalCloseBtn';
import ModalTitle from '@wconcept/wconcept-ui-renewal/components/molecules/_title/ModalTitle';
import { IconCheck01 } from '@wconcept/wconcept-ui-renewal/components/atoms/svg';
import { getResizeImageUrl } from '@wconcept/wconcept-common/utils/domainUtil';
import * as S from './style';

interface IProps {
  onClose?: () => void;
  value: { isDesktop: boolean; isIPhoneXApp: boolean; rs?: string };
}

const StylingGuideModal = ({ onClose, value }: IProps) => {
  const { isDesktop, isIPhoneXApp, rs } = value;

  const infoData = [
    "'스타일클립'은 이용자들이 다양하게 자신만의 <em>스타일링 콘텐츠</em>를 보여주는 공간입니다.",
    '스타일클립 운영 정책에 맞지 않거나 다른 이용자들에게 불편을 끼치는 게시물을 비롯해 무성의한 콘텐츠, 다른 콘텐츠와 비교하여 현저히 품질이 떨어지는 콘텐츠는 반려 및 미노출 처리됩니다. <br /> 상세 내용은 이용약관에서 확인 가능합니다.',
  ];

  const checkListData = [
    '직접 촬영한 고화질 사진 혹은 영상',
    '인물 중심 촬영 사진 혹은 영상',
    '전신 혹은 특정 아이템이 강조되는 스타일링 사진 혹은 영상',
    '첫번째 사진은 전신 사진 권장',
  ];

  const handleClose = useCallback(() => {
    if (typeof onClose === 'function') onClose();
  }, [onClose]);

  return (
    <S.StylingGuideModal>
      {isDesktop ? (
        <ModalCloseBtn onClick={handleClose} />
      ) : (
        <ModalEdgeCloseBtn onClick={handleClose} />
      )}
      <ModalTitle title="스타일링 등록 가이드" />
      <div className="content">
        <Box as="section">
          <ul className="info-list">
            {infoData.map((v, i) => (
              // eslint-disable-next-line react/no-array-index-key
              <li key={i} dangerouslySetInnerHTML={{ __html: v }} />
            ))}
          </ul>
          <div className="caption">
            *스타일링 콘텐츠란?
            <br />
            패션, 뷰티, 라이프 등 상품을 직접 착용/사용하여 스타일링하거나,
            스타일링 관련 정보가 포함된 사진 혹은 영상에 해당합니다.
          </div>
        </Box>
        <Box as="section">
          <Text
            block
            className="title"
            weight={500}
            size={16}
            lineHeight="130%"
          >
            이런 콘텐츠를 올려 주세요!
          </Text>
          <div className="guide">
            <Img
              src={getResizeImageUrl(
                '//static.wconcept.co.kr/display/images/styling_guide_sample_img2.jpg?ver=1',
                rs
              )}
              width={103}
              height={138}
            />
            <ul className="check-list">
              {checkListData.map((v, i) => (
                // eslint-disable-next-line react/no-array-index-key
                <li key={i}>
                  <IconCheck01 />
                  {v}
                </li>
              ))}
            </ul>
          </div>
        </Box>
      </div>
    </S.StylingGuideModal>
  );
};

export default StylingGuideModal;
